import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type ListUsersConfig = typeof ListUsersConfig._.Config;

export const ListUsersConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.ListUsers,
  configSchema: z.object({}),
});
